import { render, staticRenderFns } from "./StudentProfileMain.vue?vue&type=template&id=547e2c7a&scoped=true"
import script from "./StudentProfileMain.vue?vue&type=script&lang=js"
export * from "./StudentProfileMain.vue?vue&type=script&lang=js"
import style0 from "./StudentProfileMain.vue?vue&type=style&index=0&id=547e2c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e2c7a",
  null
  
)

export default component.exports